/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';

const propTypes = (member) => ({
    ...member,
    totalsRegionId: PropTypes.number
});

const defaultProps = (member) => ({
    ...member,
    totalsRegionId: null
});

const getDerivedStateFromProps = (args) => {
    const { totalsRegionId } = args[0];
    const { currentRegionId } = args[1];

    if (totalsRegionId && (!currentRegionId || currentRegionId === 1)) {
        return {
            currentRegionId: totalsRegionId
        };
    }

    return null;
};

export default {
    'Component/MyAccountAddressForm/Container': {
        'static-member': {
            propTypes,
            defaultProps,
            getDerivedStateFromProps
        }
    }
};
